import type { QueryKey } from "@tanstack/react-query";

const LOCATION_DETAIL_PATH = /^\/api\/locations\/\d+\/$/;
const PERSISTABLE_PATH_MATCHERS: ReadonlyArray<(path: string) => boolean> = [
  (path) => path === "/api/users/me/active-locations/",
  (path) => path === "/api/users/me/approved-locations/",
  (path) => path === "/api/staffer/organizations/",
  (path) => path === "/api/staffer/tos/acceptance/me/",
  (path) => path === "/api/users/me/",
  (path) => path === "/api/manager-profiles/me/",
  (path) => LOCATION_DETAIL_PATH.test(path),
];

export const isPersistableQuery = (queryKey: QueryKey | undefined) => {
  if (!Array.isArray(queryKey) || queryKey.length === 0) return false;
  const head = queryKey[0];
  return typeof head === "string" && PERSISTABLE_PATH_MATCHERS.some((matches) => matches(head));
};
